<template>
  <div class="container">
    <ul class="criteria-list">
      <li v-for="(criterion, index) in criteria" :key="index" class="criteria-item">
        <!-- タイトル行 -->
        <div class="criteria-header">
          <span v-html="(index + 1) + '. ' + criterion.title"></span>
        </div>

        <!-- 詳細カード -->
        <div class="criteria-body">
          <div class="card">
            <img :src="criterion.img" :alt="criterion.title" />
            <p class="item-detail" v-html="criterion.detail"></p>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import img1 from "@/assets/criterion/3.png";
import img3 from "@/assets/criterion/1.png";
import img4 from "@/assets/criterion/2.png";

export default {
  name: "CriterionList",
  data() {
    return {
      criteria: [
        {
          title: "即日対応可能！最短でその日にお湯が使える業者",
          img: img1,
          detail: `
「突然お湯が出なくなった」といった緊急時でも、<span class="bold-red">その日のうちにお湯が使えるようになる</span>ので、急なトラブルでも安心です。`
        },
        {
          title: "相場より安く交換できる業者",
          img: img3,
          detail: `当サイトでは<span class="bold-red">本体価格の割引率が80%を超える業者のみを掲載</span>し、工事費を含めても相場より安い業者に厳選して紹介しています。`
        },
        {
          title: "見積もり・キャンセル・相談料無料",
          img: img4,
          detail: `給湯器交換は高額になりやすいため「まずは相談や見積もりだけをしたい」という方も多いのではないでしょうか。<br><br>
          当サイトで紹介する業者は、見積もり・キャンセル・電話相談まですべて無料。<br><br><span class="bold-red">金額を聞いてからじっくり検討できるので、強引な勧誘なしで安心して比較できます。</span>`
        }
      ]
    };
  }
};
</script>

<style scoped>
.container {
  background: #fff9f1;
  padding: 20px;
}

.criteria-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.criteria-item {
  margin-bottom: 20px;
  border: 1px solid #ccc;
  border-radius: 6px;
  background: #fff;
  overflow: hidden;
}

.criteria-header {
  background: #d9e4e982;
  color: #333;
  padding: 12px 16px;
  font-size: 1.1rem;
  font-weight: 600;
}

.criteria-body {
  padding: 15px;
}

.card {
  background: #fff;
  text-align: center;
}

.card img {
  max-width: 30%;
  margin-bottom: 12px;
}

.item-detail {
  font-size: 0.95rem;
  text-align: left;
  line-height: 1.6;
}

.bold-red {
  color: #e53935;
}

.under-yellow {
  background: linear-gradient(transparent 60%, #ffff99 60%);
}

/* スマホ対応 */
@media (max-width: 600px) {
  .container {
    padding: 20px;
  }

  .criteria-header {
    font-size: 1.1rem;
    padding: 10px;
    text-align: left;
  }

  .card img {
    max-width: 60%;
  }

  .item-detail {
    font-size: 0.95rem;
  }
}
</style>
